//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBody.js";
import "../no/SelectObject.js";
let d=[[[0,"BasePoint",1,"Point",0],[1,"Blank",0,"SelectBody",0],[0,"BlankNameStr",1,0],[0,"Bottom",1,0],[0,"LeftDistance",1,0],[0,"LeftRightSide",1,0],[0,"LockPitch",1,0],[0,"LockPitchAndWidth",1,0],[0,"LockRotate",1,0],[0,"LockShiftX",1,0],[0,"LockShiftY",1,0],[0,"LockWidth",1,0],[0,"MaterialUtilization",1,0],[0,"MinimumSpaceSize",1,0],[0,"MinimumSpaceSizeValue",1,0],[0,"Pitch",1,0],[0,"RightDistance",1,0],[0,"Rotate",1,0],[0,"SideWeb",1,0],[0,"SnapSize",1,0],[0,"ThreeBlanks",1,0],[0,"Top",1,0],[0,"Type",1,0],[0,"Width",1,0],[0,"XShift",1,0],[0,"YShift",1,0]],[[[],"RepositionBottom",{},0,0],[[],"RepositionLeftDistance",{},0,0],[[],"RepositionLeftRightSide",{},0,0],[[],"RepositionPitch",{},0,0],[[],"RepositionRightDistance",{},0,0],[[],"RepositionRotate",{},0,0],[[],"RepositionSideWeb",{},0,0],[[],"RepositionTop",{},0,0],[[],"RepositionWidth",{},0,0],[[],"RepositionShiftX",{},0,0],[[],"RepositionShiftY",{},0,0],[[],"UpdateBlankLayout",{},0,0],[[],"SetBoundingBox",{},0,0],[[],"SetItemValue",{},0,0],[[],"SetMaterialUtilization",{},0,0],[["blankName"],"InsertBlank",{},1,0]],[]];
SPLM.Tooling.BlankLayoutBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.BlankLayoutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.BlankLayoutBuilder.Types = Object.freeze({
    "CreateLayout" : "CreateLayout", "AddBlank" : "AddBlank", "CopyBlank" : "CopyBlank", "RemoveBlank" : "RemoveBlank", "SetBasePoint" : "SetBasePoint", "FlipBlank" : "FlipBlank"});

SPLM.Tooling.BlankLayoutBuilder.SideWebOption = Object.freeze({
    "Average" : "Average", "Bottom" : "Bottom", "Top" : "Top"});

SPLM.Tooling.BlankLayoutBuilder.LeftRightSideOption = Object.freeze({
    "Average" : "Average", "Left" : "Left", "Right" : "Right"});

SPLM.Tooling.BlankLayoutBuilder.SnapSizeOption = Object.freeze({
    "Tenth" : "Tenth", "Fifth" : "Fifth", "Half" : "Half", "One" : "One", "Two" : "Two", "Five" : "Five", "Ten" : "Ten"});

export default SPLM;